




























import { Vue, Prop, Component } from 'vue-property-decorator'
import Button from './BaseButton.vue'
import TextInput from './BaseTextInput.vue'

@Component({
  components: { TextInput, Button },
})
export default class ReferPrompt extends Vue {
  @Prop() id: string

  on = false
  copiedToClipboard = false

  mounted () {
    setTimeout(() => {
      this.on = true
    }, 0)
  }

  get referralLink () {
    return `https://mrdavis.com?ref=${this.id}`
  }

  copyToClipboard () {
    try {
      const el = document.createElement('textarea')
      el.value = this.referralLink
      el.setAttribute('readonly', '')
      el.style.position = 'absolute'
      el.style.left = '-9999px'
      document.body.appendChild(el)
      const selected = document.getSelection()!.rangeCount > 0 ? document.getSelection()!.getRangeAt(0)! : false
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)
      if (selected) {
        document.getSelection()!.removeAllRanges()
        document.getSelection()!.addRange(selected)
      }
      // tell the user we copied it
      this.copiedToClipboard = true
    } catch (e) {
      // nothing?
    }
  }
}
